import React from "react";
import ListItem from "../../ui_atoms/ListItem";
import { RootStackParamList } from "../../navigations/RootNavigation";
import { StackScreenProps } from "@react-navigation/stack";

type MissionClientFeesProps = StackScreenProps<
    RootStackParamList,
    "MissionClientFees"
>["route"]["params"];

const MissionClientFees = ({ fees }: MissionClientFeesProps) => {
    return fees.map((displayFee) => <ListItem {...displayFee} key={displayFee.key} />);
};

export default MissionClientFees;
